import React, { FunctionComponent, useContext, useEffect } from "react";
import { sendLogoutRequest } from "../../api";
import { AppContext } from "../../app/store";
import { logError } from "../../helpers";
import { RouteComponentProps, withRouter } from "react-router";
import { ActionType, MctToastType } from "../../@types";
import { getSlsxSignoutUrl } from "../../helpers/loginHelpers";

const LogoutPage: FunctionComponent<RouteComponentProps> = ({ history }) => {
  const { state, dispatch } = useContext(AppContext);

  const logout = async () => {
    try {
      await sendLogoutRequest();
    } catch (e) {
      logError("Could not log out user (MaxGlobalHeader)", e);
    }

    history.push(`/?mctt=${MctToastType.LOGGED_OUT}`);

    dispatch({ type: ActionType.RESET_STATE });

    if (!state.csr) {
      const signoutUrl = getSlsxSignoutUrl();
      window.location.href = signoutUrl;
    }
  };

  useEffect(() => {
    logout();
  }, []);

  return <></>;
};

export default withRouter(LogoutPage);
